import script from "./ProjectTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTitle.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTitle.vue?vue&type=style&index=0&id=66a5911e&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a5911e"]])

export default __exports__